import React, { useEffect } from 'react';
import './App.scss';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import { IContent } from './types';
import { connect, ConnectedProps } from 'react-redux';
import { AppDispatch, RootState } from './store';
import { bindActionCreators } from 'redux';
import { fetchAppSetup } from './store/features/app/app';
import Hero from './components/Hero/Hero';
import Discover from './components/Discover';
import Guide from './components/Guide/Guide';
import FAQ from './components/FAQ/FAQ';
import Rewards from './components/Rewards/Rewards';
import { sendWaData } from './utils';

const mapStateToProps = (state: RootState) => ({
  app: state.app
});

const mapDisPatchToProps = (dispatch: AppDispatch) => ({
  fetchAppSetup: bindActionCreators(fetchAppSetup, dispatch)
});

const connector = connect(mapStateToProps, mapDisPatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux & {
  localeId: string;
};

const App = ({ localeId, app, fetchAppSetup }: AppProps) => {
  const localizedContent: any = data.filter(locale => locale.lang === localeId)[0];

  useEffect(() => {
    fetchAppSetup();
    sendWaData({ siteSection: 'landing page', pageName: 'wallet' });
  }, []);

  return (
    <main id='wallet-landing'>
      <ContentProvider value={localizedContent}>
        <Hero />
        <Discover />
        <Rewards />
        <Guide />
        <FAQ />
      </ContentProvider>
    </main>
  );
};

export default connector(App);
